import { useMemo } from 'react'

import { Request, RequestTicket } from 'src/types'

function AdvancesFilter({
  active,
  request_ticket_title_advances,
  request_ticket_type
}: RequestTicket) {
  return (
    active &&
    request_ticket_title_advances.length &&
    request_ticket_type === 'ADVANCE'
  )
}

function useGetAdvances(request: Request): RequestTicket[] {
  const advanceTickets = useMemo(
    () => request.request_tickets.filter(AdvancesFilter),
    [request]
  )

  return advanceTickets
}

export default useGetAdvances
